<em-main>
  @if (archivedProposalPageObject$ | async; as archivedProposalPageObject) {
    <div class="layout--column layout--gap-larger">
      @if (archivedProposalPageObject.modificationNoticeInfo) {
        <em-modification-notice-section
          [modificationNoticeInfo]="archivedProposalPageObject.modificationNoticeInfo"
          (sendModificationNotice)="onSendModificationNotice($event)"></em-modification-notice-section>
      }
      @if (archivedProposalPageObject.refusalNoticeInfo) {
        <em-refusal-notice-section
          [refusalNoticeInfo]="archivedProposalPageObject.refusalNoticeInfo"></em-refusal-notice-section>
      }
      @if (
        archivedProposalPageObject.saleReport.status === saleReportStatus.APPROVED_BY_INSURER &&
        !archivedProposalPageObject.modificationNoticeInfo?.hasModificationDecision &&
        archivedProposalPageObject.saleReport.protection.surchargeRate
      ) {
        <em-coverage-modifier-section
          [ratesVersion]="archivedProposalPageObject.ratesVersion"
          [selectedProtection]="archivedProposalPageObject.saleReport.protection"
          [archivedProtection]="archivedProposalPageObject.protection"></em-coverage-modifier-section>
      }
      <em-sale-reports-section
        i18n-title
        title="Rapport de vente"
        [props]="[archivedProposalPageObject.saleReport]"
        [readonly]="true"></em-sale-reports-section>
      <em-client-section
        [props]="archivedProposalPageObject.client"
        [creationMode]="false"
        [readonly]="true"></em-client-section>
      <em-fna-section [props]="archivedProposalPageObject.fna" [readonly]="true"></em-fna-section>
      <em-health-questionnaire-section
        [props]="{
          healthQuestionnaire: archivedProposalPageObject.healthQuestionnaire,
          healthAnswers: archivedProposalPageObject.healthAnswers,
        }"
        [readonly]="true">
      </em-health-questionnaire-section>
      <em-extra-questionnaires-section
        [props]="archivedProposalPageObject.extraQuestionnaireInfo"
        (propsChange)="updateExtraQuestionnaires($event)"
        (uploadDocuments)="uploadDocuments($event)"
        (downloadDocument)="downloadDocument($event)"
        (deleteDocument)="removeDocument($event)"
        (completeQuestionnaires)="completeExtraQuestionnaires($event)"></em-extra-questionnaires-section>

      <em-archived-protection-section
        [needs]="archivedProposalPageObject.fna.needs!"
        [protection]="archivedProposalPageObject.protection"></em-archived-protection-section>
      <em-beneficiaries-section
        [props]="archivedProposalPageObject.beneficiaries"
        [province]="archivedProposalPageObject.client.province"
        [totalCoverage]="archivedProposalPageObject.totalCoverage"
        [readonly]="true"></em-beneficiaries-section>
      <em-address-section [props]="archivedProposalPageObject.address" [readonly]="true"></em-address-section>
      <em-id-document-section [props]="archivedProposalPageObject.idDocument" [readonly]="true">
      </em-id-document-section>
      @if (archivedProposalPageObject.disclosures) {
        <em-disclosures-section
          [props]="archivedProposalPageObject.disclosures"
          [primaryAgentFullName]="archivedProposalPageObject.disclosures.primaryAgentFullName"
          [clientFullName]="clientFullName(archivedProposalPageObject.client)"
          [idDocument]="archivedProposalPageObject.idDocument"
          [readonly]="true">
        </em-disclosures-section>
      }
    </div>
  } @else {
    <em-skeleton></em-skeleton>
  }
</em-main>

<p-toast></p-toast>
